import React from 'react';
import { HelpCircle, ChevronDown, MessageCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

export function FAQPage() {
  const faqs = [
    {
      question: "Are your gold items BIS Hallmarked?",
      answer: "Yes, 100% of our gold jewellery is BIS Hallmarked. We provide valid certificates and hallmark stamps on every piece to ensure you get the purity promised (22K, 18K, etc.)."
    },
    {
      question: "Do you offer custom jewellery design?",
      answer: "Absolutely! We specialize in bespoke bridal and traditional Rajasthani designs. You can visit our Alwar store to discuss your vision with our master craftsmen."
    },
    {
      question: "How do I know my ring or bangle size?",
      answer: "You can refer to our detailed Size Guide page. If you're still unsure, we recommend visiting our store for a professional measurement."
    },
    {
      question: "How should I care for my silver jewellery?",
      answer: "Silver naturally oxidizes over time. Store it in airtight pouches and avoid contact with perfumes or sweat. Visit our Care Instructions page for more detailed tips."
    }
  ];

  return (
    <div className="min-h-screen bg-white pb-20">
      {/* Hero Section */}
      <section className="bg-brand-green text-white py-16 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="flex justify-center mb-6 animate-in fade-in zoom-in duration-700">
            <HelpCircle className="h-16 w-16 text-brand-gold" />
          </div>
          <h1 className="text-4xl font-serif mb-4 animate-in fade-in slide-in-from-bottom-4 duration-700">
            Frequently Asked <span className="text-brand-gold">Questions</span>
          </h1>
          <p className="text-brand-gold/80 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200">
            Everything you need to know about our products, purity, and services.
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 px-6 max-w-3xl mx-auto">
        <div className="space-y-4">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-border rounded-xl px-6 bg-white shadow-sm hover:border-brand-green/30 transition-all duration-300 animate-in fade-in slide-in-from-bottom-4"
                style={{ animationDelay: `${index * 100}ms` }}
              >
              <AccordionTrigger className="text-left font-serif text-brand-green text-lg py-6 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-6 text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      {/* Contact CTA */}
        <div className="mt-20 text-center bg-brand-gold/5 rounded-3xl p-10 border border-brand-gold/20">
          <h3 className="text-2xl font-serif text-brand-green mb-4">Still have questions?</h3>
          <p className="text-muted-foreground mb-8">Our experts are happy to help you with any queries.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <a 
              href="https://wa.me/919829050157" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 bg-[#25D366] text-white px-6 py-3 rounded-xl hover:opacity-90 transition-opacity"
            >
              <MessageCircle className="h-5 w-5" />
              <span>Chat on WhatsApp</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
